import React from "react"
import { X } from "lucide-react"
import { motion } from "framer-motion"

const CityInput = ({ value, onClear }) => {
  return (
    <div className="flex items-center gap-3 flex-1">
      <div className="relative flex-1">
        <div className="bg-second-success/30 text-sm rounded-md px-2 py-1 flex items-center justify-between group hover:bg-second-success/60 transition-colors">
          <span className="bg-transparent text-second-success truncate font-medium w-full">
            {value}
          </span>
          <motion.button
            key="clear"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            transition={{ duration: 0.9, ease: "easeOut" }}
            onClick={onClear}
            className="ml-2 text-second-success hover:text-error cursor-pointer"
          >
            <X className="w-3 h-3" />
          </motion.button>
        </div>
      </div>
    </div>
  )
}

export default CityInput
